import 'src/styles/ui/section-label.css';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import iconNode from 'src/components/ui/iconNode';

/**
 * A small labelled section divider: an optional leading icon, the label text,
 * an optional trailing hint, and an optional trailing action — joined by a
 * hairline rule. Pass `plain` for a heading-style label with no rule. Generic:
 * usable by any feature that groups content under short labels.
 *
 * `icon` accepts a FontAwesome icon definition, a component type, or a node.
 */
const SectionLabel = ({ icon, children, hint, action, plain, className, ...props }) => (
  <div
    className={classNames('section-label', { 'section-label--plain': plain }, className)}
    {...props}
  >
    {iconNode(icon)}
    {children}
    {hint != null && <span className='section-label__hint'>{hint}</span>}
    {action}
  </div>
);

SectionLabel.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.node]),
  children: PropTypes.node,
  hint: PropTypes.node,
  action: PropTypes.node,
  plain: PropTypes.bool,
  className: PropTypes.string,
};

SectionLabel.defaultProps = {
  icon: null,
  children: null,
  hint: null,
  action: null,
  plain: false,
  className: '',
};

export default SectionLabel;
